var minOrderQty = 1;

function showStatusMessage(msg,timeout){
  timeout = timeout || 1500;
  $('.status-msg .inner-msg').html(msg);
  $('.status-msg').addClass('visible');
  setTimeout(function(){$('.status-msg').removeClass('visible');}, timeout);
}

function getQuantityInput(handle) {
 	return $('.product-tile__quantity-val[data-product-handle="' + handle + '"]'); 
}

function filterProducts(filter) {
  var _products = filter.split('|');
  var _showAll = filter.trim() == '';
  	
  $('.product-tile').each(function() {
    if (_showAll) {
    	$(this).removeClass('filter-enabled');
    } else {
      if (_products.includes($(this).attr('data-handle'))) {
      	$(this).removeClass('filter-enabled');
      } else {
      	$(this).addClass('filter-enabled');
      }
    }
  });
}


var _productsToAdd = [];
var _productIndex = 0;

function addNextSoup(callback) {
  if (_productsToAdd.length <= _productIndex) {
    if (typeof callback === 'function') { callback(); }
    return false;
  }
  
  var _product = _productsToAdd[_productIndex++];
  
  $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: _product,
      success: function(response) {
        addNextSoup(callback);
      },
      error: function(response) {
        console.log('Error adding product to cart:');
        console.log(response);   
		addNextSoup(callback);     
      }
   });
  
  return true;
}

$(document).ready(function() {
  localStorage.setItem('hasSelectedBox', 'yes');
  localStorage.setItem('cleanseSelections', '');
  
  
  $('.product-selection #selection-filter').change(function(e) {
    
    filterProducts($(this).val());
    
  });
  
  $('.review-order-btn').click(function(e) {
    e.preventDefault();
    
    if (typeof $('.review-order-btn').attr('disabled') !== 'undefined') {
      return; 
    }

    var _total = 0;
    _productsToAdd = [];
    
    $('.product-tile').each(function() {
      var _id = $(this).attr('data-product-id');
      var _count = $(this).find('.product-tile__quantity-val').val();
      if (isNaN(_count)) { 
        _count = 0; 
      } else {
        _count = parseInt(_count);
        if (_count > 100) {
         _count = 100; 
        } else if (_count < 0) {
         _count = 0; 
        }
      }
      
      if (_count > 0) {
        _productsToAdd.push({
          id: parseInt(_id),
          quantity: _count
        });
      	_total += _count;
      }
    });
    
    if (_total < 6) {
      	showStatusMessage('Please select at least 6 soups');
    } else {
      $('.review-order-btn').attr('disabled', 'disabled');
      $('.review-order-btn').text('Loading...');
      addNextSoup(function() {
      	window.location.href = '/cart'; 
      });
    }
  });
  
  $('.product-tile__quantity-increase').click(function() {
    var _handle = $(this).attr('data-product-handle');
    var _input = getQuantityInput(_handle);
    var _value = parseInt($(_input).val());
    if (_value < 100) {
    	$(_input).val(_value + 1);
    }
  });
  
  $('.product-tile__quantity-decrease').click(function() {
    var _handle = $(this).attr('data-product-handle');
    var _input = getQuantityInput(_handle);
    var _value = parseInt($(_input).val());
    if (_value > 0) {
    	$(_input).val(_value - 1);
    }
  });
  
  $('.product-tile__quantity-val').change(function() {
    var _value = parseInt($(this).val());
    if (isNaN(_value) || _value < 0) {
      $(this).val(0);
    } else if (_value > 100) {
      $(this).val(100); 
    }
  });
  
});